import { Quotation } from 'data-layer-cr/dist/models';

import InspectionRequest, {
  InspectionRequestImprovement,
} from './InspectionRequest';

import { InspectionFormState } from '../../store/inspectionForm/slice/inspectionFormSlice';

// eslint-disable-next-line import/prefer-default-export
export function makeInspectionRequest(
  quotation: Quotation,
  formState: InspectionFormState,
): InspectionRequest {
  return {
    inspectionId: quotation.urlSalt,
    quotationId: quotation.id,
    previousDamages: formState.textValues.previousDamages,
    improvements: formState.textValues.carImprovements.map(
      (improv): InspectionRequestImprovement => ({
        name: improv.name,
        value: improv.value.toString(),
      }),
    ),
    vin:
      formState.textValues.vinNumber || quotation.units[0].unit.serialChassis,
    licensePlate:
      formState.textValues.licensePlate || quotation.units[0].unit.licensePlate,
    serialMotor:
      formState.textValues.serialMotor || quotation.units[0].unit.serialMotor,

    // hardcoded values
    ipAddress: '127.0.0.1',
    userAgent: '',
  };
}
